module.exports = __webpack_public_path__ + "static/media/IMG_1185.ae1c041f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/food/IMG_1185.jpg
// module id = 76
// module chunks = 0